/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Backdrop, Box, Breadcrumbs, Button, CircularProgress, Container, FormControlLabel, Grid, Link, Switch, Typography } from '@material-ui/core';
import { customerApi } from '../../../api/customerApi';
import useMounted from '../../../hooks/useMounted';
import ChevronRightIcon from '../../../icons/ChevronRight';
import gtm from '../../../lib/gtm';
import useAuth from '../../../hooks/useAuth';
import CustomerNewProspectsListTable from './CustomerNewProspectsListTable';
import PlusIcon from '../../../icons/Plus';
import UploadIcon from '../../../icons/Upload';
import { DownloadIcon } from 'lucide-react';
import ImportModal from '../../CSVImport/ImportModal';
import ExportDialog from './ExportDialog';
import UsersIcon from '../../../icons/Users';
import { alpha } from '@mui/material/styles';
import { lightVeil, greyAlpha, grey } from '../../../theme/tones';
import usePermissions from '../../../hooks/usePermissions';

const CustomerNewProspects = () => {
  const mounted = useMounted();
  const { user } = useAuth();
  const { can } = usePermissions();
  const [loading, setLoading] = useState(true);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [numberCustomers, setNumberCustomers] = useState(0);
  const [usersCampaign, setUsersCampaign] = useState([]);
  const [usersRelance, setUsersRelance] = useState([]);
  const [modeRelance, setModeRelance] = useState(false);
  const [relance, setRelance] = useState(false);
  const [endSessions, setEndSessions] = useState([]);
  const [customersEndSessions, setCustomersEndSessions] = useState([]);
  const [choiceTabProfession, setChoiceTabProfession] = useState('');
  const [choiceSort, setChoiceSort] = useState('lastname|asc');
  const [choiceSource, setChoiceSource] = useState('');
  const [choiceCampaign, setChoiceCampaign] = useState('');
  const [choiceCallTrack, setChoiceCallTrack] = useState('');
  const [choiceNewCallTrack, setChoiceNewCallTrack] = useState('');
  const [choiceCallTrackRelance, setChoiceCallTrackRelance] = useState('');
  const [choiceAvancement, setChoiceAvancement] = useState('');
  const [choiceEndSession, setChoiceEndSession] = useState('');
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  function initRelance() {
    const rel = {};
    usersRelance.forEach((element) => {
      rel[element.id] = null;
    });
    rel.empty = null;
    return rel;
  }

  const [choiceRelance, setChoiceRelance] = useState(initRelance);
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(25);

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  const location = useLocation();

  useEffect(() => {
    // Les choice permettent de garder les choix de filtre même en changeant de page
    let tempChoiceTabProfession = window.localStorage.getItem('choiceTabProfession');
    tempChoiceTabProfession = tempChoiceTabProfession === null ? 'all' : window.localStorage.getItem('choiceTabProfession').replaceAll('"', '');
    setChoiceTabProfession(tempChoiceTabProfession);
    let tempChoiceSort = window.localStorage.getItem('choiceSort');
    tempChoiceSort = tempChoiceSort === null ? 'lastname|asc' : window.localStorage.getItem('choiceSort').replaceAll('"', '');
    setChoiceSort(tempChoiceSort);
    let tempChoiceSource = window.localStorage.getItem('choiceSource');
    tempChoiceSource = tempChoiceSource === null ? '' : window.localStorage.getItem('choiceSource').replaceAll('"', '');
    setChoiceSource(tempChoiceSource);
    let tempChoiceCampaign = window.localStorage.getItem('choiceCampaign');
    tempChoiceCampaign = tempChoiceCampaign === null ? '' : window.localStorage.getItem('choiceCampaign').replaceAll('"', '');
    setChoiceCampaign(tempChoiceCampaign);
    let tempChoiceCallTrack = window.localStorage.getItem('choiceCallTrack');
    tempChoiceCallTrack = tempChoiceCallTrack === null ? '' : window.localStorage.getItem('choiceCallTrack').replaceAll('"', '');
    setChoiceCallTrack(tempChoiceCallTrack);
    let tempChoiceNewCallTrack = window.localStorage.getItem('choiceNewCallTrack');
    tempChoiceNewCallTrack = tempChoiceNewCallTrack === null ? '' : window.localStorage.getItem('choiceNewCallTrack').replaceAll('"', '');
    setChoiceNewCallTrack(tempChoiceNewCallTrack);
    let tempChoiceCallTrackRelance = window.localStorage.getItem('choiceCallTrackRelance');
    tempChoiceCallTrackRelance = tempChoiceCallTrackRelance === null ? '' : window.localStorage.getItem('choiceCallTrackRelance').replaceAll('"', '');
    setChoiceCallTrackRelance(tempChoiceCallTrackRelance);
    let tempChoiceAvancement = window.localStorage.getItem('choiceAvancement');
    tempChoiceAvancement = tempChoiceAvancement === null ? '' : window.localStorage.getItem('choiceAvancement').replaceAll('"', '');
    setChoiceAvancement(tempChoiceAvancement);
    let tempChoiceEndSession = window.localStorage.getItem('choiceEndSession');
    tempChoiceEndSession = tempChoiceEndSession === null ? '' : window.localStorage.getItem('choiceEndSession').replaceAll('"', '');
    setChoiceEndSession(tempChoiceEndSession);
    let tempChoiceRelance = window.localStorage.getItem('choiceRelance');
    tempChoiceRelance = tempChoiceRelance === null ? '' : window.localStorage.getItem('choiceRelance').replaceAll('"', '');
    setChoiceRelance(tempChoiceRelance);
  }, []);

  const getProspect = useCallback(async () => {
    try {
      let data = [];
      let tempChoiceProfession = window.localStorage.getItem('choiceTabProfession');
      tempChoiceProfession = tempChoiceProfession === null ? 'all' : window.localStorage.getItem('choiceTabProfession').replaceAll('"', '');
      let tempChoiceSource = window.localStorage.getItem('choiceSource');
      tempChoiceSource = tempChoiceSource === null ? 'all' : window.localStorage.getItem('choiceSource').replaceAll('"', '');
      let tempChoiceCampaign = window.localStorage.getItem('choiceCampaign');
      tempChoiceCampaign = tempChoiceCampaign === null ? 'all' : window.localStorage.getItem('choiceCampaign').replaceAll('"', '');
      let tempChoiceCallTrack = window.localStorage.getItem('choiceCallTrack');
      tempChoiceCallTrack = tempChoiceCallTrack === null ? 'all' : window.localStorage.getItem('choiceCallTrack').replaceAll('"', '');
      let tempChoiceNewCallTrack = window.localStorage.getItem('choiceNewCallTrack');
      tempChoiceNewCallTrack = tempChoiceNewCallTrack === null ? 'all' : window.localStorage.getItem('choiceNewCallTrack').replaceAll('"', '');
      let tempChoiceCallTrackRelance = window.localStorage.getItem('choiceCallTrackRelance');
      tempChoiceCallTrackRelance = tempChoiceCallTrackRelance === null ? 'all' : window.localStorage.getItem('choiceCallTrackRelance').replaceAll('"', '');
      let tempChoiceAvancement = window.localStorage.getItem('choiceAvancement');
      tempChoiceAvancement = tempChoiceAvancement === null ? 'all' : window.localStorage.getItem('choiceAvancement').replaceAll('"', '');
      let tempChoiceEndSession = window.localStorage.getItem('choiceEndSession');
      tempChoiceEndSession = tempChoiceEndSession === null ? 'all' : window.localStorage.getItem('choiceEndSession').replaceAll('"', '');
      let tempChoiceRelance = window.localStorage.getItem('choiceRelance');
      tempChoiceRelance = tempChoiceRelance === null ? 'all' : window.localStorage.getItem('choiceRelance').replaceAll('"', '');
      
      setLoading(true);
      if (location.pathname === '/dashboard/prospects') {
        mounted.current = true;
        if (query === '' && tempChoiceProfession === 'all' && user.access_level === 0) {
          // aucun résultat retourné
          setCustomers([]);
          setNumberCustomers(0);
          setUsersCampaign([]);
          setUsersRelance([]);
        } else {
          data = await customerApi.getProspect(window.localStorage.getItem('accessToken'), query, choiceSort, tempChoiceSource, tempChoiceCampaign, tempChoiceCallTrack,
            tempChoiceNewCallTrack, tempChoiceCallTrackRelance, tempChoiceAvancement, tempChoiceEndSession, tempChoiceRelance, tempChoiceProfession, limit, page, modeRelance);
          setCustomers(data.customers);
          setNumberCustomers(data.numberCustomers);
          setUsersCampaign(data.usersCampaign);
          setUsersRelance(data.usersRelance);
        }
        setCustomersEndSessions(data.customers_end_sessions || []);
      } else if (location.pathname === '/dashboard/campagne') {
        mounted.current = true;
        data = await customerApi.getCustomersCampagne(window.localStorage.getItem('accessToken'), query, choiceSort, tempChoiceSource, tempChoiceCampaign, tempChoiceCallTrack,
          tempChoiceNewCallTrack, tempChoiceCallTrackRelance, tempChoiceAvancement, tempChoiceEndSession, tempChoiceRelance, tempChoiceProfession, limit, page, modeRelance);
        setCustomers(data.customers);
      }

      if (mounted.current) {
        setEndSessions(data.end_sessions || []);
        setLoading(false);
        setLoadingFilter(false);

        if (user.id_service === 4) {
          setRelance(true);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted, location]);

  useEffect(() => {
    getProspect();
  }, [getProspect]);

  return (
    <>
      <Helmet>
        <title>Tableau de bord: Liste des prospects | Syndays</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 4,
          transition: 'all 0.3s'
        }}
      >
        <Container maxWidth={false} disableGutters sx={{ px: 2 }}>
          {/* ── Hero Header ── */}
          <Box
            sx={{
              mb: 4,
              p: 3.5,
              borderRadius: '24px',
              border: '1px solid',
              borderColor: (theme) => alpha(theme.palette.divider, 0.8),
              background: `linear-gradient(135deg, ${lightVeil(0.9)} 0%, ${greyAlpha(100, 0.7)} 100%)`,
              backdropFilter: 'blur(20px)',
              boxShadow: (theme) => `0 4px 24px ${alpha(theme.palette.common.black, 0.04)}`,
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'flex-start', md: 'center' },
              justifyContent: 'space-between',
              gap: 3,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: '16px',
                  background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: (theme) => `0 8px 20px ${alpha(theme.palette.secondary.main, 0.3)}`,
                  flexShrink: 0,
                }}
              >
                <UsersIcon style={{ color: grey(0), fontSize: '1.7rem', width: 28, height: 28 }} />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: '1.5rem',
                    color: 'text.primary',
                    letterSpacing: '-0.02em',
                    lineHeight: 1.2,
                  }}
                >
                  Liste des prospects
                </Typography>
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator={<ChevronRightIcon fontSize="small" />}
                  sx={{ mt: 1, mb: 1 }}
                >
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    to="/dashboard"
                    variant="subtitle2"
                    sx={{ textDecoration: 'none', '&:hover': { color: 'secondary.main' } }}
                  >
                    Tableau de bord
                  </Link>
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    to="/dashboard"
                    variant="subtitle2"
                    sx={{ textDecoration: 'none', '&:hover': { color: 'secondary.main' } }}
                  >
                    Gestion
                  </Link>
                  <Typography
                    color="textPrimary"
                    variant="subtitle2"
                    sx={{ fontWeight: 600 }}
                  >
                    Prospects
                  </Typography>
                </Breadcrumbs>
              </Box>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
              <Button
                color="primary"
                component={RouterLink}
                startIcon={<PlusIcon fontSize="small" />}
                to="/dashboard/customers/create"
                sx={{
                  background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                  boxShadow: (theme) => `0 4px 12px 0 ${alpha(theme.palette.secondary.main, 0.25)}`,
                  color: grey(0),
                  borderRadius: '12px',
                  px: 3,
                  py: 1.2,
                  textTransform: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                    transform: 'translateY(-1px)',
                    boxShadow: (theme) => `0 6px 16px 0 ${alpha(theme.palette.secondary.main, 0.35)}`
                  },
                  transition: 'all 0.2s ease-in-out'
                }}
                variant="contained"
              >
                Ajouter un prospect
              </Button>
              
              {can('prospects.import', user.id_service === 0 || user.id_service === 4) && (
                <Button
                  color="primary"
                  startIcon={<UploadIcon fontSize="small" />}
                  onClick={() => setImportModalOpen(true)}
                  sx={{
                    borderRadius: '12px',
                    border: (theme) => `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
                    backgroundColor: (theme) => alpha(theme.palette.common.white, 0.8),
                    px: 2.5,
                    py: 1.2,
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': {
                      backgroundColor: (theme) => alpha(theme.palette.secondary.main, 0.04),
                      borderColor: 'secondary.main',
                      transform: 'translateY(-1px)'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                  variant="outlined"
                >
                  Importer des contacts
                </Button>
              )}
              
              {can('prospects.export', user.id_service === 0 && user.access_level === 0) && (
                <Button
                  color="primary"
                  startIcon={<DownloadIcon fontSize="small" />}
                  onClick={() => setExportModalOpen(true)}
                  sx={{
                    borderRadius: '12px',
                    border: (theme) => `1px solid ${alpha(theme.palette.text.disabled, 0.3)}`,
                    backgroundColor: (theme) => alpha(theme.palette.common.white, 0.8),
                    px: 2.5,
                    py: 1.2,
                    textTransform: 'none',
                    fontWeight: 600,
                    color: 'text.secondary',
                    '&:hover': {
                      backgroundColor: greyAlpha(100, 0.8),
                      borderColor: 'divider',
                      transform: 'translateY(-1px)'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                  variant="outlined"
                >
                  Exporter
                </Button>
              )}
            </Box>
          </Box>
          <Box sx={{ mt: 1 }}>
            <CustomerNewProspectsListTable
              customers={customers} // Liste des apprenants
              usersCampaign={usersCampaign} // Utilisateurs à assigner en Campagne
              isRelance={relance} // Permet de savoir si l'utilisateur fait partie exclusivement du service Relance
              modeRelance={modeRelance} // Permet de savoir si on est en mode Relance pour l'administrateur
              usersRelance={usersRelance} // Utilisateurs à assigner du service relance
              endSessions={endSessions} // Date de toutes les fins de sessions en bdd
              customersEndSessions={customersEndSessions} // Tableau de fins de sessions des apprenants
              choiceTabProfession={choiceTabProfession} // si préfixe choice, permet de garder en mémoire le changement de filtre
              choiceSort={choiceSort}
              choiceSource={choiceSource}
              choiceCampaign={choiceCampaign}
              choiceCallTrack={choiceCallTrack}
              choiceNewCallTrack={choiceNewCallTrack}
              choiceCallTrackRelance={choiceCallTrackRelance}
              choiceAvancement={choiceAvancement}
              choiceEndSession={choiceEndSession}
              query={query}
              setQuery={setQuery}
              setCustomers={setCustomers}
              numberCustomers={numberCustomers}
              setNumberCustomers={setNumberCustomers}
              loading={loading}
              loadingFilter={loadingFilter}
              page={page}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}
              relance={choiceRelance}
              setRelance={setChoiceRelance}
            />
            <Backdrop
              sx={{ color: grey(0), zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
        </Container>
      </Box>
      <ImportModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
      />
      <ExportDialog
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
      />
    </>
  );
};

export default CustomerNewProspects;

